import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { mapGetters } from 'vuex';
import * as usertypes from '@account/store/types'
import MyInfoWebpart from '@home/components/FixedWebpart/MyInfoWebpart.vue'
import MyCountWebpart from '@home/components/FixedWebpart/MyCountWebpart.vue'
import NoticeTicker from '@home/components/FixedWebpart/NoticeTicker.vue'

@Component({
    components:{
        MyCountWebpart, MyInfoWebpart,NoticeTicker 
    },
    computed: mapGetters({
        userCurrent: usertypes.CURRENT
    })
})
export default class FixedWebpartContainer extends Vue {
    userCurrent!: account.TCurrent

    // roleId 9999를 가지고 있으면 true
    get isOutsourcingRole(): boolean {
        return this.userCurrent.permissions.roles.some((role: any) => role.id === 1210)
    }
}
